import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Alert,
  CircularProgress
} from '@mui/material';
import { AutoAwesome, Add } from '@mui/icons-material';

interface AiModalProps {
  open: boolean;
  onClose: () => void;
  onGenerate: () => void;
  onInsert: () => void;
  prompt: string;
  setPrompt: (value: string) => void;
  response: string;
  setResponse: (value: string) => void;
  isLoading: boolean;
  error: string | null;
}

const AiModal: React.FC<AiModalProps> = ({
  open,
  onClose,
  onGenerate,
  onInsert,
  prompt,
  setPrompt,
  response,
  setResponse,
  isLoading,
  error
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth sx={{ zIndex: 10000 }}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoAwesome color="secondary" />
          Gerar Texto com IA
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', md: 'row' } }}>
          {/* Campo do Prompt */}
          <Box sx={{ flex: 1 }}>
            <TextField
              autoFocus
              label="Descreva o que você quer que a IA escreva"
              placeholder="Ex: Escreva um parágrafo sobre os benefícios da tecnologia na educação"
              fullWidth
              multiline
              rows={6}
              variant="outlined"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              disabled={isLoading}
              sx={{ mb: 1 }}
            />
            <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
              💡 Dicas: Seja específico sobre o tom, estilo e conteúdo desejado.
            </Box>
          </Box>

          {/* Campo da Resposta */}
          <Box sx={{ flex: 1 }}>
            <TextField
              label="Resposta da IA"
              placeholder="A resposta da IA aparecerá aqui..."
              fullWidth
              multiline
              rows={6}
              variant="outlined"
              value={response}
              onChange={(e) => setResponse(e.target.value)}
              disabled={isLoading}
              sx={{ mb: 1 }}
              InputProps={{
                readOnly: false, // Permite edição da resposta
              }}
            />
            <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
              ✏️ Você pode editar a resposta antes de inserir no editor.
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          onClick={onGenerate}
          variant="outlined"
          disabled={isLoading || !prompt.trim()}
          startIcon={isLoading ? <CircularProgress size={20} /> : <AutoAwesome />}
        >
          {isLoading ? 'Gerando...' : 'Gerar Texto'}
        </Button>
        <Button
          onClick={onInsert}
          variant="contained"
          disabled={!response.trim() || isLoading}
          startIcon={<Add />}
        >
          Inserir no Editor
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiModal;
